import React from "react";

const STYLES = `
  /* ── Boxed variant ── */
  .tb-boxed {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-radius: 10px;
    overflow: hidden;
    margin-top: -15px;
    position: relative;
    z-index: 111;
   
  }
  .tb-boxed .tb-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 14px 14px;
    justify-content: center;
    background: #000;
  }
  .tb-boxed .tb-item:last-child { border-bottom: none; }
  .tb-boxed .tb-icon {
    flex-shrink: 0;
    width: 75px; height: 52px;
    border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
    color: var(--bgr-orange, #ff6a2b);
  }
  .tb-boxed .tb-title {
    font-size: 0.82rem; font-weight: 600;
    color: #be8d48;
    text-transform: uppercase; letter-spacing: 0.02em;
    margin: 0 0 2px; line-height: 1.3;
  }
  .tb-boxed .tb-subtitle { font-size: 0.7rem; color: #8a8a8a; margin: 0; line-height: 1.3; }

  /* ── Tablet & mobile: horizontal scroll ── */
  @media (max-width: 768px) {
    .tb-boxed {
      display: flex;
      grid-template-columns: none;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      scroll-snap-type: x proximity;
      scrollbar-width: none; /* Firefox */
    }
    .tb-boxed::-webkit-scrollbar { display: none; } /* Chrome/Safari */

    .tb-boxed .tb-item {
      flex: 0 0 auto;
      min-width: 160px;
      scroll-snap-align: start;
      border-bottom: none;
    }
    .tb-boxed .tb-item:last-child { border-right: none; }
  }

  @media (max-width: 480px) {
    .tb-boxed .tb-item {
      min-width: 140px;
      padding: 12px 12px;
    }
    .tb-boxed .tb-icon { width: 44px; height: 44px; }
  }

  /* ── Plain variant ── */
  .tb-plain {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    border-top: 1px solid #e8e8e8;
    padding: 18px 4px;
    margin: 10px 0;
  }
  .tb-plain .tb-item { display: flex; flex-direction: column; align-items: center; text-align: center; gap: 8px; }
  .tb-plain .tb-icon {
    width: 34px; height: 34px; border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
    background: #f6f6f6; color: #333;
  }
  .tb-plain .tb-title { font-size: 0.74rem; font-weight: 700; color: #222; margin: 0 0 2px; }
  .tb-plain .tb-subtitle { font-size: 0.66rem; color: #8a8a8a; margin: 0; line-height: 1.3; }

  @media (min-width: 640px) {
    .tb-plain { grid-template-columns: repeat(3, 1fr); gap: 18px; padding: 22px 4px; }
  }

  /* Optional: also scroll the plain variant on small screens */
  @media (max-width: 640px) {
    .tb-plain {
      display: flex;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      scroll-snap-type: x proximity;
      scrollbar-width: none;
    }
    .tb-plain::-webkit-scrollbar { display: none; }
    .tb-plain .tb-item {
      flex: 0 0 auto;
      min-width: 110px;
      scroll-snap-align: start;
    }
  }
`;

function TrustBadges({ items = [], variant = "boxed" }) {
  if (!items.length) return null;
  return (
    <div className={variant === "boxed" ? "tb-boxed" : "tb-plain"}>
      <style>{STYLES}</style>
      {items.map((item, i) => (
        <div className="tb-item" key={i}>
          <span className="tb-icon">
            <img src={item.icon} style={{ width: "100%" }} />
          </span>
          <div>
            <p className="tb-title">{item.title}</p>
            <p className="tb-subtitle">{item.subtitle}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TrustBadges;